import React, { useEffect, useState } from "react";
import './App.css';
import List from '../src/components/List.js';


const App = () => {
    const [todo, setTodo] = useState("");
    const [allTodos, setAllTodos] = useState([]);
    const addTodo = (e) => {
        e.preventDefault();

        const todoItem = {
            id: new Date().getTime(),
            text: todo,
            isChecked: false
        }

        if(todo !== "") {
            setAllTodos([...allTodos].concat(todoItem).reverse())
            setTodo("")
        }
    }

    const getAllTodos = () => {
        let stored = JSON.parse(localStorage.getItem("todo"));

        if(stored) {
            setAllTodos(stored)
        }
    }

    const toggleChecked = () => {
        let updatedTodos = [...allTodos].map(todo => {
            if(todo.id) {
                todo.isChecked = !todo.isChecked;
            }
            return todo;
        })
        setAllTodos(updatedTodos);
    }

    const deleteTodo = (id) => {
        const filteredTodo = allTodos.filter(todo => todo.id !== id);
        setAllTodos(filteredTodo);
    }

    useEffect(() => {
        getAllTodos();
    }, [])

    useEffect(() => {
        localStorage.setItem("todo", JSON.stringify(allTodos))
    }, [allTodos])

    var isClkd = false;
    var chng = ()  => {
        isClkd = !isClkd;
    }
    

    return (
        <div className="app">
            <div className="app-holder">
                <div className="app-top">
                    <h1 className="app-title">TODO</h1>
                    <span onClick={chng}  className="app-lighting">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"><path fill="#FFF" fill-rule="evenodd" d="M13 21a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-5.657-2.343a1 1 0 010 1.414l-2.121 2.121a1 1 0 01-1.414-1.414l2.12-2.121a1 1 0 011.415 0zm12.728 0l2.121 2.121a1 1 0 01-1.414 1.414l-2.121-2.12a1 1 0 011.414-1.415zM13 8a5 5 0 110 10 5 5 0 010-10zm12 4a1 1 0 110 2h-3a1 1 0 110-2h3zM4 12a1 1 0 110 2H1a1 1 0 110-2h3zm18.192-8.192a1 1 0 010 1.414l-2.12 2.121a1 1 0 01-1.415-1.414l2.121-2.121a1 1 0 011.414 0zm-16.97 0l2.121 2.12A1 1 0 015.93 7.344L3.808 5.222a1 1 0 011.414-1.414zM13 0a1 1 0 011 1v3a1 1 0 11-2 0V1a1 1 0 011-1z"/></svg>
                    </span>
                </div>
                <form className="app-new-todo" onSubmit={addTodo}>
                    <div className="app-radio" onClick={addTodo}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9"><path fill="none" stroke="#FFF" stroke-width="2" d="M1 4.304L3.696 7l6-6"/></svg>
                    </div>
                    <input type={"text"} className="app-input" value={todo} onChange={(e) => setTodo(e.target.value)} />
                </form>
                <div className="app-todo-list">
                    {
                        allTodos.map(todo => (
                            <List key={todo.id} deleteTodo={() => deleteTodo(todo.id)} text={todo.text} isChecked={todo.isChecked} toggleChecked={() => toggleChecked(todo.id)} />
                        ))
                    }
                </div>
            </div>
            
        </div>
    ); 
}

export default App;